/* eslint-disable @typescript-eslint/no-explicit-any */
import { ENVIRONMENT } from '@app/environment';
import { Injectable } from '@rxdi/core';

@Injectable({ init: true })
export class AnalyticsService {
  private trackingId = ENVIRONMENT.GOOGLE_MEASUREMENT_ID;

  constructor() {
    if (!window.origin.includes('localhost')) {
      this.initGA();
    }
  }

  private initGA() {
    if (typeof window === 'undefined') return;

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.trackingId}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    };

    window.gtag('js', new Date());
    window.gtag('config', this.trackingId);
    console.log('GA4 Loaded dynamically successfully via Vanilla JS');
  }

  page(data?: any) {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'page_view', {
        page_title: data?.title || document.title,
        page_path: data?.path || window.location.pathname,
      });
    }
  }

  track(eventName: string, properties?: { [key: string]: any }) {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', eventName, properties);
      console.log(`GA4 Tracked Event: ${eventName}`, properties);
    }
  }
}

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}
